/*
 * @Author: your name
 * @Date: 2022-02-28 13:35:28
 * @LastEditTime: 2022-03-10 12:39:21
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ant-design-vue-jeecg\src\utils\user_manager.js
 */
import { UserManager } from '@do/do-auth-web-client'
export const userManager = new UserManager()
userManager.init({
  env: window.ENV_CONFIG.env,
  loginUrl: window.ENV_CONFIG.loginUrl2,
  baseUrl: window.ENV_CONFIG.baseUrl
})
